import '@nike/eds/dist/index.css'
import OktaAuth from '@okta/okta-auth-js'
import { Security } from '@okta/okta-react'
import AuthConfig from 'auth/AuthConfig'
import { SnackBar } from 'components/snackbar'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Routes } from 'router/Routes'

function App () {
  const clientAuth = new OktaAuth(AuthConfig.oidc)
  const navigate = useNavigate()

  clientAuth.start().catch(error => {
    console.log(error)
  })

  const restoreOriginalUri = async (_oktaAuth: any, originalUri: string) => {
    navigate('/')
  }

  useEffect(() => {
    return () => {
      clientAuth.options.restoreOriginalUri = undefined
    }
  }, [])

  return (
    <Security
      oktaAuth={clientAuth}
      restoreOriginalUri={restoreOriginalUri}>
      <SnackBar />
      <Routes />
    </Security>
  )
}

export default App
